var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"flex-grow-1 bg-white p-3"},[(_vm.data.length==0)?_c('h5',{staticClass:"mt-5 text-center"},[_vm._v("目前沒有紀錄")]):_vm._e(),_vm._l((_vm.data),function(r,i){return _c('RecordListItem',{key:i,attrs:{"data":r}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }